export interface QuizzesItem {
  uniqueId: string;
  id: number;
  parentId: number | null;
}

interface ParentQuizzesItem {
  children: string[];
}

export type QuizOrFolder = Folder | Quiz;
export interface Folder extends QuizzesItem, ParentQuizzesItem {
  type: 'folder';
  name: string;
  deleted: boolean;
  date: Date;
  sharable?: boolean;
  disable?: boolean;
  parentId: number | null;
  locked?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type ItemPath = Array<{
  uniqueId: string;
}>;

export interface Quiz extends QuizzesItem {
  type: 'quiz';
  name: string;
  soc: string;
  date: Date;
  sharable: boolean;
  parentId: number | null;
  deleted: boolean;
  version: number;
  standard: string;
  locked?: boolean;
}

export interface FolderResponse {
  id: number;
  name: string;
  deleted: boolean;
  parentId: number | null;
  lastUpdated: string;
}

export interface QuizResponse {
  id: number;
  name: string;
  parentId: number | null;
  soc: string;
  date: string;
  sharable: boolean;
  deleted: boolean;
  version: number;
  standard: string;
  locked?: boolean;
}

export interface QuizzesResponse {
  folders: FolderResponse[];
  quizzes: QuizResponse[];
}

export const quizzesItemTypes = ['folder', 'quiz'] as const;
export type QuizzesItemType = typeof quizzesItemTypes[number];
